import React from "react";

export const Arrow: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 24 24"
    >
      <defs />
      <path
        fillRule="nonzero"
        d="M23.987 11.52a2.277 2.277 0 00-.814-1.728L11.994.347A1.482 1.482 0 0010 .504a1.343 1.343 0 00.094 1.918l8.637 7.296a.232.232 0 01.068.264.253.253 0 01-.233.156H1.452c-.795 0-1.44.619-1.44 1.382 0 .763.645 1.382 1.44 1.382h17.111a.25.25 0 01.232.156.235.235 0 01-.067.265l-8.637 7.296a1.354 1.354 0 00-.511 1.328c.097.499.47.907.974 1.063a1.483 1.483 0 001.437-.317l11.181-9.445a2.274 2.274 0 00.815-1.728z"
      />
    </svg>
  );
};
